/* eslint-disable import/prefer-default-export */
export const BrowserDocumentInteractive = ({ children }) => {
  if (typeof document === "undefined" || document?.readyState === "loading") return "";
  return children;
};
